import React, { useState, useContext } from 'react';
import { Modal } from '@op/opds.opux-modal';
import { Button, ButtonRow } from '@op/opds.opux';
import { Message, useMessageGetter } from '@messageformat/react';
import { StateContext, ChangeStateContext } from '../State';
import { Mode, ErrorCode, fullpageloginRootId, cancelButtonContainerId } from '../constants';

const VerificationCancelButton = (props) => {
    const state = useContext(StateContext);
    const changeState = useContext(ChangeStateContext);
    const [modalOpen, setModalOpen] = useState(false);
    const msg = useMessageGetter('fp');

    const onVerificationCancelClick = () => {
        console.debug('onVerificationCancelClick called');
        setModalOpen(true);
    };

    const onVerificationCancelAbort = () => {
        console.debug('onVerificationCancelAbort called');
        setModalOpen(false);
    };

    const onVerificationCancelConfirm = () => {
        console.debug('onVerificationCancelConfirm called');
        setModalOpen(false);
        changeState({ errorCode: ErrorCode.VERIFICATION_CANCEL });
    };

    /* Only show button during verification */
    const visible = state.mode === Mode.LOGIN && state.authType && !state.errorCode;

    /* Forcibly close modal if it was left open and should not be visible anymore */
    if (!visible && modalOpen) {
        setModalOpen(false);
    }

    return (
        <div id={cancelButtonContainerId}>
            {visible && (
                <>
                    <ButtonRow>
                        <Button alternate onClick={onVerificationCancelClick}>
                            <Message id='fp.verification.cancelButtonText' />
                        </Button>
                    </ButtonRow>
                    <Modal
                        appElement={document.getElementById(fullpageloginRootId)}
                        footer={
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                <Button compact onClick={onVerificationCancelAbort}>
                                    <Message id='fp.cancelConfirmation.no' />
                                </Button>
                                <Button compact onClick={onVerificationCancelConfirm}>
                                    <Message id='fp.cancelConfirmation.yes' />
                                </Button>
                            </div>
                        }
                        isOpen={modalOpen}
                        onUpdate={(modalState) => {
                            setModalOpen(modalState.open);
                        }}
                        title={msg('cancelConfirmation.title')}
                    >
                        <div className='opux-v6__opds'>
                            <p>
                                <Message id='fp.cancelConfirmation.body' />
                            </p>
                        </div>
                    </Modal>
                </>
            )}
        </div>
    );
};

export default VerificationCancelButton;
